export default __webpack_public_path__ + "media/flavours/glitch/images/mbstobon-ui-2-6c5e94fac80476dbc6271425c55582aa.png";